import React from "react";
import ReactDOM from "react-dom";
import ProdutoModel from "../model/ProdutoModel";
import C5CompraItemModel from "../model/C5CompraItemModel";

import C5ProdutoDAO from "../dataAccess/C5/C5ProdutoDAO";
import LojaModel from "../model/LojaModel";

type PedidoItemProps = {
  item: C5CompraItemModel;
  loja: LojaModel | null;
  parent: React.Component;
};

type PedidoItemState = {
  showObservacao: boolean;
  produto?: ProdutoModel;
};

class PedidoItem extends React.Component<PedidoItemProps, PedidoItemState> {
  constructor(props: PedidoItemProps) {
    super(props);

    this.toggleObservacao = this.toggleObservacao.bind(this);

    this.state = {
      showObservacao: false,
    };
  }

  componentDidMount(): any {
    const { item, loja } = this.props;
    if (loja) {
      C5ProdutoDAO.getInstance()
        .getById(item.produtoId, loja.lojaId)
        .then((produto: ProdutoModel | null) => {
          if (produto) {
            if (this.props.item) {
              produto.quantidade = item.quantidade ? item.quantidade : 1;
              produto.precoOriginal = item.precoUnitario ? item.precoUnitario : produto.precoOriginal;
              produto.precoDesconto = item.precoUnitarioDesconto ? item.precoUnitarioDesconto : produto.precoDesconto;
            }

            this.setState({ produto });
          }
        });
    }
  }

  toggleObservacao(): any {
    this.setState({ showObservacao: !this.state.showObservacao });
    const seta: any = ReactDOM.findDOMNode(this.refs.seta);
    seta.classList.toggle("fa-chevron-down");
    seta.classList.toggle("fa-chevron-up");
  }

  render(): any {
    const { item } = this.props;
    const { produto, showObservacao } = this.state;

    if (produto) {
      if (item.nome.toUpperCase().indexOf(" KG") > -1)
      {
        produto.fatorMultiplicacao = 1000;
        produto.unidade = "GR";
      }

      produto.precoDesconto = item.precoUnitarioDesconto;
      produto.precoOriginal = item.precoUnitario;

      return (
        <li className="item" ref="itemRef">
          <div className="product">
            <div className="info">
              <div className="photo">
                <img
                  src={produto.imagem}
                  alt={ProdutoModel.getNome(produto)}
                  title={ProdutoModel.getNome(produto)}
                />
              </div>
              <div className="details">
                <p className="upper">{produto.marca}</p>
                { produto.unidade !== "GR" &&
                <>
                  <p className="middle">{produto.quantidade}x {ProdutoModel.getNome(produto)}</p>
                  <p className="bottom">
                    {`R$ ${(produto.precoDesconto).toFixed(2).replace(".", ",")}`}
                    &nbsp;<span>{ProdutoModel.getGR(produto)}</span> <br/>
                  </p>
                </>
                }
                { produto.unidade === "GR" &&
                <>
                  <p className="middle">{produto.nome}</p>
                  <p className="bottom">
                    {`R$ ${(produto.precoDesconto).toFixed(2).replace(".", ",")}`}
                    &nbsp;<span>KG</span> <br/>
                  </p>
                </>
                }
              </div>
              <div className="menu">
                <div className="items">
                  <div className="total">
                    { produto.unidade === "GR" &&
                    <div className="price">
                      R$ {(produto.precoDesconto * produto.quantidade).toFixed(2).replace(".", ",")}<br/>
                      <span>{ProdutoModel.getGR(produto, produto.quantidade)}</span>
                    </div>
                    }
                    { produto.unidade !== "GR" &&
                    <div className="price">
                      R$ {(produto.precoDesconto * produto.quantidade).toFixed(2).replace(".", ",")}<br/>
                    </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="notes">
            <div 
              className="notes-title"
              onClick={this.toggleObservacao}
            >
              <div className="detail">OBSERVACÕES</div>
              <i className="icon fas fa-chevron-down" ref="seta"></i>
            </div>
            {showObservacao && (
              <>
                {item.notas && item.notas.length > 0 && (
                  <p className="notes-text">{item.notas}</p>
                )}
                {(!item.notas || (item.notas && item.notas.length === 0)) && (
                  <p className="notes-text">
                    <i>Nenhuma observação informada</i>
                  </p>
                )}
              </>
            )}
          </div>
          
        </li>
      );
    } else {
      return "";
    }
  }
}

export default PedidoItem;
